/**
 * Client Portal entrypoint.
 *
 * Order matters:
 *   1. `@ram/ui/no-fouc` — applies the theme to <html> before Vue mounts.
 *   2. styles + tokens — once via the bundler.
 *   3. i18n locale + RTL direction — before App renders.
 *   4. Pinia + Router — state + navigation.
 */
import "@ram/ui/no-fouc";
import "./styles.css";
import "@ram/ui/styles/auth";

import { createApp } from "vue";
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";
import {
  applyDocumentLocale,
  messages,
  readStoredLocale,
} from "@ram/i18n";

import App from "./App.vue";
import { router } from "./router";

const startingLocale = readStoredLocale("en");
applyDocumentLocale(startingLocale);

const i18n = createI18n({
  legacy: false,
  locale: startingLocale,
  fallbackLocale: "en",
  messages,
});

createApp(App).use(createPinia()).use(router).use(i18n).mount("#app");
